import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Search, CheckCircle, Wrench } from "lucide-react";
import { WhatsAppCTA } from "../WhatsAppCTA";
import { fadeUp, staggerContainer, viewport } from "../../lib/motion";

const STEPS = [
  { num: "01", icon: MessageCircle, title: "Você chama", description: "Conte o que aconteceu com seu aparelho." },
  { num: "02", icon: Search, title: "A gente entende", description: "Conversamos sobre o problema e avaliamos o que pode ser feito." },
  { num: "03", icon: CheckCircle, title: "Você decide", description: "Você sabe o que será feito antes do serviço começar." },
  { num: "04", icon: Wrench, title: "Seu aparelho é cuidado", description: "O serviço é realizado após sua aprovação." },
];

export const Process = () => {
  return (
    <section
      id="processo"
      data-testid="process-section"
      className="relative bg-[#050505] py-28 md:py-40 border-t border-white/[0.05]"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="text-center max-w-2xl mx-auto"
        >
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-[#f5f5f7]">
            Simples assim.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#86868b]">
            Quatro passos. Sem complicação.
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="mt-20 relative grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6"
        >
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-6 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={i}
                variants={fadeUp}
                data-testid={`process-step-${i + 1}`}
                className="relative flex flex-col items-center text-center"
              >
                <div className="relative z-10 w-12 h-12 rounded-full bg-[#1a1a1a] border border-white/10 flex items-center justify-center mb-6">
                  <Icon size={20} className="text-[#f5f5f7]" strokeWidth={1.8} />
                </div>
                <span className="text-xs font-semibold tracking-[0.2em] text-[#86868b]">
                  {step.num}
                </span>
                <h3 className="mt-3 text-lg md:text-xl font-bold tracking-tight text-[#f5f5f7]">
                  {step.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#86868b] max-w-[220px]">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>

        <div className="mt-16 flex justify-center">
          <WhatsAppCTA label="Falar no WhatsApp" testId="process-whatsapp" />
        </div>
      </div>
    </section>
  );
};
